// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3tUOf","buttons":"PendingPaymentAlert_buttons__3dNop"};